import LegalLayout, {
  LegalSection,
  LegalParagraph,
  LegalList,
  LegalLabeledRows,
  type UnsfNavbarProps,
  type UnsfFooterProps,
} from "@/components/unsf/LegalLayout"
import type { UnsfMeta } from "@/components/unsf/UnsfHead"

interface Props {
  meta: UnsfMeta
  title: string
  last_updated: string
  entity: {
    section_title: string
    rows: Array<{ label: string; value: string }>
    email: { label: string; address: string }
  }
  sections: Array<{ title: string; text: string }>
  delivery: { title: string; items: string[] }
  withdrawal: { title: string; intro: string; items: string[] }
  navbar: UnsfNavbarProps
  footer: UnsfFooterProps
  csrf_token: string
  cart: import("@/components/unsf/Cart").CartData
}

export default function Cgv({
  meta,
  title,
  last_updated,
  entity,
  sections,
  delivery,
  withdrawal,
  navbar,
  footer,
  csrf_token,
  cart,
}: Props) {
  return (
    <LegalLayout
      meta={meta}
      title={title}
      intro={last_updated}
      navbar={navbar}
      footer={footer}
      csrfToken={csrf_token}
      cart={cart}
    >
      <LegalSection title={entity.section_title}>
        <LegalLabeledRows rows={entity.rows} email={entity.email} />
      </LegalSection>

      {sections.slice(0, 5).map((section) => (
        <LegalSection key={section.title} title={section.title}>
          <LegalParagraph>{section.text}</LegalParagraph>
        </LegalSection>
      ))}

      <LegalSection title={delivery.title}>
        <ul className="text-content space-y-3 list-disc pl-6">
          {delivery.items.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      </LegalSection>

      <LegalSection title={withdrawal.title}>
        <p className="text-content leading-relaxed mb-4">{withdrawal.intro}</p>
        <LegalList items={withdrawal.items} />
      </LegalSection>

      {sections.slice(5).map((section, idx) => (
        <LegalSection
          key={section.title}
          title={section.title}
          className={idx === sections.slice(5).length - 1 ? "mb-0" : ""}
        >
          <LegalParagraph>{section.text}</LegalParagraph>
        </LegalSection>
      ))}
    </LegalLayout>
  )
}
